import { Ifilter } from "../../Interfaces/filter";
import { IBodyUpdatePlantilla, IDeletePlatillaPropiedadDetalle, IPlantillaVerificacionPOST } from "../../Interfaces/IPlantillaVerificacion";
import { fetchListVerificacion } from "../http-common";

const plantillasVerificacion = (filter?: Ifilter) => {
    return fetchListVerificacion.get(`PlantillaVerficacion/ListarPlantilla`, { params: filter });
}
const POSPlantillaVerificacion = (body: IPlantillaVerificacionPOST) => {
    return fetchListVerificacion.post(`PlantillaVerficacion/Crear`, body);
}

const GetDetallePlantilla = (PlantillaVerificacionId: string) => {
    return fetchListVerificacion.get(`PlantillaVerficacion/Detalle?PlantillaVerificacionId=${PlantillaVerificacionId}`);
}
const DeletePlantilla = (PantillaVerificacionId: string) => {
    return fetchListVerificacion.delete(`PlantillaVerficacion/${PantillaVerificacionId}`,);
}


const DeletePropiedadPlantilla = (BodyDeleId: IDeletePlatillaPropiedadDetalle) => {
    return fetchListVerificacion.delete(`PlantillaVerficacion/EliminarDetalle?PlantillaVerificacionId=${BodyDeleId.PantillaVerificacionId}&PropiedadVerificaccionId=${BodyDeleId.PropiedadVerificaccionId}`);
}

const ActulizarPlantilla = (BodyPUT: IBodyUpdatePlantilla) => {
    return fetchListVerificacion.put(`PlantillaVerficacion/Actulizar`, BodyPUT)
}

const plantillaVerificacionService = {
    plantillasVerificacion,
    POSPlantillaVerificacion,
    GetDetallePlantilla,
    DeletePlantilla,
    ActulizarPlantilla,
    DeletePropiedadPlantilla
}


export default plantillaVerificacionService;